import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormGroup, AbstractControl } from '@angular/forms';

@Pipe({
    name: 'ngxIsRequiredField',
    standalone: false
})
export class IsRequiredFieldPipe implements PipeTransform {
  transform(formGroup: UntypedFormGroup, field: string): boolean {
    const formField = formGroup.get(field);
    if (!formField.validator) {
      return false;
    }

    const validator = formField.validator({} as AbstractControl);
    return validator && validator.required;
  }
}
